<mat-list *ngrxLet="eventable$ as eventable">
  <pr-event-time [event]="eventable.event" />
  <pr-event-participants [event]="eventable.event" />
</mat-list>
